import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { isAppInWebView, isMobileOrTablet } from 'helpers/Device';
import { translate } from 'helpers/Translate';

import logoSm from 'images/logo-small.svg';
import logo from 'images/logo.svg';
import { getHabitationValuationUrl } from 'helpers/Estima';

const Header = ({ authenticated, children, className, title, step }) => {
    const wrapperClasses = classnames({
        header: true,
        [className]: !!className,
    });
    const logoHref = isAppInWebView() ? '/estimation-immobiliere/form' : '/';

    return (
        <div className={wrapperClasses}>
            <div className="header__logo">
                <a
                    href={logoHref}
                    className="inline-block"
                    data-ua-command="event"
                    data-ua-event-category="Navigation"
                    data-ua-event-action="go:home"
                    data-ua-event-label="nav:logo"
                >
                    <img
                        src={logoSm}
                        alt="Immobilier avec MeilleursAgents"
                        style={{ width: 25, height: 25 }}
                        className="hide-lg vertical-align-middle"
                    />
                    <img
                        src={logo}
                        alt="Immobilier avec MeilleursAgents"
                        className="hide-sm vertical-align-middle"
                    />
                </a>
            </div>
            {title && (
                <div className="header__title">
                    {!isMobileOrTablet() && title.desktop}
                    {isMobileOrTablet() && title.mobile}
                </div>
            )}
            {isAppInWebView() && authenticated && step === 1 && (
                <div className="header__link-portfolio">
                    <a href={getHabitationValuationUrl()}>{translate('Liste de biens')}</a>
                </div>
            )}
            {children}
        </div>
    );
};

Header.displayName = 'Header';

Header.propTypes = {
    authenticated: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    title: PropTypes.shape({
        desktop: PropTypes.string,
        mobile: PropTypes.string,
    }),
    step: PropTypes.number,
};

Header.defaultProps = {
    children: null,
};

/**
 * Header Functional Component.
 */
export default Header;
